import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { FotoboxRecord } from '../types';

const API_URL = import.meta.env.VITE_API_URL || '';

export function useSocket(
  onBoxUpdate: (box: FotoboxRecord) => void,
  token: string,
  onReconnect?: () => void,
) {
  const callbackRef = useRef(onBoxUpdate);
  callbackRef.current = onBoxUpdate;

  const reconnectRef = useRef(onReconnect);
  reconnectRef.current = onReconnect;

  useEffect(() => {
    const socket: Socket = io(API_URL, {
      transports: ['websocket', 'polling'],
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      auth: { token },
    });

    let everConnected = false;

    socket.on('connect', () => {
      if (everConnected) {
        // Reconnect nach Verbindungsabbruch → verpasste Events nachholen
        reconnectRef.current?.();
      }
      everConnected = true;
    });

    socket.on('box:update', (box: FotoboxRecord) => {
      callbackRef.current(box);
    });

    // Wenn der Browser-Tab nach längerem Hintergrund wieder sichtbar wird,
    // kann der Socket eingefroren sein (kein disconnect, aber keine Events mehr).
    // In dem Fall Verbindung erzwingen → der connect-Handler holt dann die Daten nach.
    const onVisibility = () => {
      if (document.visibilityState === 'visible' && !socket.connected) {
        socket.connect();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      socket.disconnect();
    };
  }, [token]);
}
